export default "__VITE_ASSET__ddd43265__"